import { Box, Divider, Flex, Group, Kbd, Paper, ScrollArea, Stack, Text } from "@mantine/core";
import { DEVICE_DISCIPLINE_MAPPING, DisciplineEnum } from "@multiconsult-group/multiplacer-core";
import DeviceIcon from "../../SelectedSpace/DeviceIcon";
import { HOTKEYS } from "../../constants";
import { IDeviceCategoryEnum } from "@backend/src/shared/schemas/foundationSchema";

const formatShortcut = (shortcut: string): string[] =>
  shortcut
    .split("+")
    .map((part) => part.trim())
    .filter(Boolean);

const formatAction = (action: string): string =>
  action
    .split("_")
    .map((part) => part.toLowerCase())
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

const HelpPanel = () => {
  return (
    <Flex direction="column" h="100%" style={{ minHeight: 0 }}>
      <ScrollArea h="100%" style={{ flex: 1, minHeight: 0 }} type="auto" scrollbarSize={8}>
        <Stack gap="md" pr="xs" pb="md">
          <DeviceTypeTable />
          <HotkeyTable />
        </Stack>
      </ScrollArea>
    </Flex>
  );
};

export default HelpPanel;

const DeviceTypeTable: React.FC = () => {
  const rows = Object.entries(DEVICE_DISCIPLINE_MAPPING)
    .map(([key, value]) => {
      return {
        discipline: value,
        deviceCategory: key,
      };
    })
    .filter((item) => item.discipline !== DisciplineEnum.ARCHITECTURE);

  return (
    <Paper withBorder radius="md" p={0} bg="white">
      <Box px="md" py="sm">
        <Text fw={700} size="lg">
          Produkttyper
        </Text>
      </Box>
      <Divider />

      <Stack gap={0}>
        {rows.map((row) => (
          <Group
            key={row.deviceCategory}
            justify="space-between"
            gap="md"
            wrap="nowrap"
            px="md"
            py="sm"
            style={{ borderBottom: "1px solid #f1f3f5" }}
          >
            <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
              <DeviceIcon deviceType={row.deviceCategory as IDeviceCategoryEnum} />
              <Text size="sm" truncate title={row.deviceCategory}>
                {row.deviceCategory}
              </Text>
            </Group>
            <Text size="sm" c="dimmed" style={{ flexShrink: 0 }}>
              {row.discipline}
            </Text>
          </Group>
        ))}
      </Stack>
    </Paper>
  );
};

const HotkeyTable: React.FC = () => {
  const rows = Object.entries(HOTKEYS).map(([key, value]) => {
    return {
      action: key,
      shortcut: value,
    };
  });

  return (
    <Paper withBorder radius="md" p={0} bg="white">
      <Box px="md" py="sm">
        <Text fw={700} size="lg">
          Hurtigtaster
        </Text>
      </Box>
      <Divider />

      <Stack gap={0}>
        {rows.map((row) => (
          <Group
            key={row.action}
            justify="space-between"
            gap="md"
            wrap="nowrap"
            px="md"
            py="sm"
            style={{ borderBottom: "1px solid #f1f3f5" }}
          >
            <Text size="sm" style={{ minWidth: 0 }}>
              {formatAction(row.action)}
            </Text>
            <Group gap={4} wrap="nowrap" style={{ flexShrink: 0 }}>
              {formatShortcut(row.shortcut).map((part) => (
                <Kbd key={`${row.action}-${part}`}>{part}</Kbd>
              ))}
            </Group>
          </Group>
        ))}
      </Stack>
    </Paper>
  );
};
